type PublicRouteMetadata = {
  path: `/${string}`;
  access: "public";
  title: string;
};

type LazyRouteManifestEntry<TModule extends object> = PublicRouteMetadata & {
  load: () => Promise<TModule>;
  componentName: Extract<keyof TModule, string>;
};

const defineLazyRoute = <TModule extends object>(
  route: LazyRouteManifestEntry<TModule>,
): LazyRouteManifestEntry<TModule> => route;

/**
 * First bounded route-manifest projection. Keep this as one route until its
 * router, access, extraction, and bundle behavior has been reviewed.
 */
export const loginRouteManifest = defineLazyRoute({
  path: "/login",
  access: "public",
  title: "Login",
  load: () => import("@libs/Login/Login"),
  componentName: "Login",
});
